module.exports = __webpack_public_path__ + "static/media/ecom-cart.4c766731.gif";